import React, { useEffect, useState } from "react";
import { loadStripe, Stripe as StripeType } from "@stripe/stripe-js";
import { Button } from "./Button";

const REACT_APP_STRIPE_PK = process.env["REACT_APP_STRIPE_PK"];
const stripePromise = loadStripe(REACT_APP_STRIPE_PK || "");

interface StripeCheckoutButtonProps {
  priceId: string;
  label: string;
  markPaid?: () => void;
  successUrl: string;
  paymentFailureUrl: string;
}

export const StripeCheckoutButton: React.FC<StripeCheckoutButtonProps> = ({
  priceId,
  label,
  markPaid,
  successUrl,
  paymentFailureUrl,
}) => {
  const [stripe, setStripe] = useState<StripeType | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const fetchStripe = async () => {
      const stripe = await stripePromise;
      setStripe(stripe);
    };

    fetchStripe();
  }, []);

  const handleClick = async (event: React.MouseEvent): Promise<void> => {
    event.preventDefault();
    setBusy(true);

    if (!stripe) {
      setBusy(false);
      return;
    }

    const { error } = await stripe.redirectToCheckout({
      lineItems: [{ price: priceId, quantity: 1 }],
      mode: "payment",
      cancelUrl: `${window.location.protocol}//${window.location.host}${paymentFailureUrl}`,
      successUrl: `${window.location.protocol}//${window.location.host}${successUrl}`,
    });

    if (error) {
      console.error("Error in redirectToCheckout:", error);
    }

    setBusy(false);
  };

  return (
    <Button variant="primary" size="large" disabled={busy} onClick={handleClick}>
      {label}
    </Button>
  );
};
